export default "__VITE_ASSET__BP07kAIf__"